module.exports = __webpack_public_path__ + "static/media/loading.4b195de8.gif";